import ViewViewModel from '@/ViewModels/ViewViewModel';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';
import Loader from '@/Utility/Loader';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';

/**
 * Repräsentiert das ViewModel des Logouts
 */
export default class LogoutViewModel extends ViewViewModel {

    public constructor(params: CoreFrameInterfaces.LogoutViewModelConstructorParameter) {
        super(params);

        Loader.getInstance().show();

        RADEnvironmentProxy.getInstance().whenAllRequestsAreResponded().then(() => {
            RADApplication.getInstance().beforeLogout();

            RADEnvironmentProxy.getInstance().logout()
                .always(() => RADApplication.getInstance().afterLogout());
        });
    }
}

ComponentManager.setViewModel('LogoutViewModel', LogoutViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');